import { createStore } from 'vuex'

export default createStore({
	state: {
		snackBar: {},
		notifications: [],
	},
	getters: {},
	mutations: {},
	actions: {},
})
